import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';

import { Button } from '@common/components';

import { useTranslation } from '@common/utils';
import { Link } from 'react-router-dom';

function Banner({ params }) {
	const classes = useStyles();
	const tr = useTranslation();
	const { locale } = useSelector(state => state.locale);

	return (
		<div className={classes.banner}>
			<Typography variant="h3">
				{tr('Need more rooms?')}
			</Typography>
			<div className={classes.action}>
				<Button color="dark" style={{ minWidth: '240px' }} component={Link} to={`/${params}&language=${locale}`}>{tr('Add Room')}</Button>
			</div>
			<Typography variant="body2" className={classes.note}>
				{tr('We will hold your reservation until you add all rooms you need.')}
			</Typography>
		</div>
	);
}

Banner.propTypes = {
	params: PropTypes.string,
};

export default Banner;

const useStyles = makeStyles(theme => ({
	banner: {
		border: `1px solid ${theme.palette.custom.borders}`,
		borderRadius: '4px',
		marginBottom: theme.spacing(5),
		padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
		textAlign: 'center',

		[theme.breakpoints.up('md')]: {
			padding: `${theme.spacing(4)}px ${theme.spacing(3)}px`,
		},
	},
	action: {
		padding: theme.spacing(3),
	},
	note: {
		color: theme.palette.primary.light,
	},
}));
